module.exports = __webpack_public_path__ + "static/media/car_top_2.102c30f3.png";